/**
 * Fields displayed in the "Main Inspection Information" section
 * => Everything except the date fields + the new ones you want
 */
export const inspectionMainInfo = [
  { name: "agencyName",       label: "Agency",          type: "text",  readOnly: true },
  { name: "inspectionNumber", label: "Inspection #",    type: "text",  readOnly: true },
  { name: "taskType",         label: "Task Type",       type: "text" },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "Active", label: "Active" },
      { value: "Inactive", label: "Inactive" },
    ],
  },
  /**{ name: "managementCompanyId", label: "Management Company ID", type: "text" }, */
  { name: "inspYear",            label: "Inspection Year",       type: "text" },
];

/**
 * Fields in the "Other Information" section
 * => specifically "test id", "building site", "customer name"
 */
export const inspectionOtherInfo = [
  { name: "categoryInspection", label: "Test ID",       type: "text", readOnly: true },
  { name: "buildingSite",       label: "Building Site", type: "text", readOnly: true },
  { name: "customerName",       label: "Customer Name", type: "text" },
];

/**
 * Fields in the "Company Information" section
 */
export const inspectionCompanyInfo = [
  { name: "maintenanceCoId", label: "Maintenance Co", type: "serviceCompanySelect" },
  { name: "performingCoId",  label: "Performing Co",  type: "serviceCompanySelect" },
  { name: "witnessCoId",     label: "Witness Co",     type: "serviceCompanySelect" },
];

/**
 * Fields in the "Dates Information" section
 * => approvalDate, lastDate, nextDate
 */
export const inspectionDatesInfo = [
  { name: "approvalDate", label: "Scheduled Date", type: "date" },
  { name: "lastDate",     label: "Last Date",      type: "date" },
  { name: "nextDate",     label: "Next Date",      type: "date" },
];
